import type { DeveloperTranslation } from './types';

/** Urdu. Pending review by native speakers. */
export const developerUr: DeveloperTranslation = {
  nav: 'ڈویلپر',
  title: 'ڈویلپر',
  description:
    'اپنے سسٹم جوڑیں: سرور انٹیگریشن کے لیے API کلیدیں، انہیں ہونے والے واقعات بتانے والے ویب ہُک، اور وہ ہوسٹ جنہیں Hamnivo کال کر سکتا ہے۔',
  apiReference: 'API حوالہ',
  newTab: '(نئے ٹیب میں کھلتا ہے)',
  tabs: {
    keys: 'API کلیدیں',
    webhooks: 'ویب ہُک',
    events: 'ایونٹ لاگ',
    hosts: 'اجازت یافتہ ہوسٹ',
  },
  reveal: {
    description: 'اسے محفوظ جگہ رکھیں؛ یہ دوبارہ نہیں دکھایا جائے گا۔',
    copy: 'کاپی کریں',
    copied: 'کاپی ہو گیا',
    copyFailed: 'کاپی نہیں ہو سکا۔ متن منتخب ہے؛ اسے خود کاپی کریں۔',
    once: 'Hamnivo اس کا صرف ایک فنگر پرنٹ رکھتا ہے۔ کھو جانے پر نیا لینے کے لیے اسے روٹیٹ کریں۔',
    done: 'ہو گیا',
  },
  permissions: {
    analytics: {
      read: {
        name: 'رپورٹیں پڑھیں',
        hint: 'سروس کے معیار کے مجموعی اعداد اور CSV ایکسپورٹ۔ پیغامات کا مواد نہیں۔',
      },
    },
    billing: {
      read: { name: 'بلنگ پڑھیں', hint: 'پلان، اس کی حدوں کے مقابلے میں استعمال، اور انوائسز۔' },
    },
    webhooks: {
      read: {
        name: 'ویب ہُک پڑھیں',
        hint: 'اینڈ پوائنٹس، ڈلیوری لاگ اور ایونٹ کی اقسام۔ سائننگ راز نہیں۔',
      },
    },
    mcp: {
      read: {
        name: 'MCP سے پڑھنا',
        hint: 'Claude جیسے اے آئی معاون کو گفتگو تلاش کرنے، گاہکوں نے جو دیکھا وہ پڑھنے، اور معلومات، گاہک کی یادداشت اور کھلے ہینڈ آف دیکھنے دیتا ہے۔ صرف پڑھنے کے لیے۔',
      },
    },
  },
  keys: {
    title: 'API کلیدیں',
    description:
      'کلید کی مدد سے کوئی سرور اپنے سروس اکاؤنٹ کے طور پر Hamnivo API کال کر سکتا ہے — صرف اُن اجازتوں کے ساتھ جو آپ دیں، اور کبھی آپ کی اجازتوں سے زیادہ نہیں۔',
    readOnly:
      'آپ کلیدیں دیکھ سکتے ہیں، مگر انہیں بنانا یا بدلنا صرف API کلیدیں سنبھالنے والے لوگ کر سکتے ہیں۔',
    loading: 'API کلیدیں لوڈ ہو رہی ہیں',
    empty: 'ابھی کوئی API کلید نہیں۔',
    neverUsed: 'کبھی استعمال نہیں ہوئی',
    scopeTenant: 'پورا ورک اسپیس',
    scopeBrand: 'برانڈ: {{brand}}',
    scopeType: {
      workspace: 'ایک ورک اسپیس',
      brand: 'ایک برانڈ',
      team: 'ایک ٹیم',
      inbox: 'ایک اِن باکس',
    },
    status: {
      active: 'فعال',
      rotating: 'تبدیل ہو رہی ہے',
      expired: 'میعاد ختم',
      revoked: 'منسوخ',
    },
    columns: {
      name: 'نام',
      key: 'کلید',
      access: 'رسائی',
      status: 'حالت',
      lastUsed: 'آخری استعمال',
      expires: 'اختتام',
      actions: 'کارروائیاں',
    },
    create: {
      open: 'کلید بنائیں',
      title: 'API کلید بنائیں',
      description: 'کلید کو صرف وہی دیں جس کی انٹیگریشن کو ضرورت ہے۔ ہر کلید کی میعاد ختم ہوتی ہے۔',
      name: 'نام',
      nameHint: 'ایسا نام جو بتائے کہ یہ کہاں استعمال ہوتی ہے، جیسے ”آرڈر سسٹم“۔',
      permissions: 'اجازتیں',
      notYours: 'یہ اجازت آپ کے پاس خود نہیں ہے، اس لیے آپ اسے نہیں دے سکتے۔',
      scope: 'کہاں لاگو ہو',
      scopeHint: 'بلنگ اور ویب ہُک ہمیشہ پورے ورک اسپیس پر لاگو ہوتے ہیں۔',
      expiry: 'میعاد',
      expiryHint: 'میعاد ختم ہونے سے پہلے کلید روٹیٹ کریں؛ پرانی کلید کچھ دیر چلتی رہ سکتی ہے۔',
      days: '{{count}} دن',
      submit: 'کلید بنائیں',
    },
    rotate: {
      button: 'روٹیٹ کریں',
      label: '{{name}} روٹیٹ کریں',
      title: '”{{name}}“ روٹیٹ کریں؟',
      description:
        'آپ کو اُنہی اجازتوں والی نئی کلید ملے گی۔ اپنی انٹیگریشن اپ ڈیٹ کریں، پھر پرانی کلید کو ختم ہونے دیں۔',
      overlap: 'پرانی کلید چلتی رہے گی',
      overlaps: {
        '0': 'بالکل نہیں: ابھی بند',
        '60': 'ایک گھنٹہ',
        '1440': 'ایک دن',
        '10080': 'ایک ہفتہ',
      },
      confirm: 'کلید روٹیٹ کریں',
      unchanged: 'کلید روٹیٹ نہیں ہوئی؛ موجودہ کلید اب بھی چلتی ہے۔',
    },
    revoke: {
      button: 'منسوخ کریں',
      label: '{{name}} منسوخ کریں',
      title: '”{{name}}“ منسوخ کریں؟',
      description: 'اس کلید والی درخواستیں فوراً کام کرنا بند کر دیں گی۔ اسے واپس نہیں کیا جا سکتا۔',
      confirm: 'کلید منسوخ کریں',
      done: '{{name}} منسوخ کر دی گئی۔',
    },
    reveal: {
      title: 'API کلید بن گئی',
      label: '{{name}} کے لیے API کلید',
    },
  },
  webhooks: {
    title: 'ویب ہُک',
    description:
      'کچھ ہونے پر Hamnivo آپ کے اینڈ پوائنٹس پر سائن شدہ HTTPS درخواستیں بھیجتا ہے۔ اندرونی نوٹس کبھی نہیں بھیجے جاتے۔',
    add: 'اینڈ پوائنٹ شامل کریں',
    loading: 'ویب ہُک اینڈ پوائنٹس لوڈ ہو رہے ہیں',
    empty: 'ابھی کوئی اینڈ پوائنٹ نہیں۔ ایونٹس لینے کے لیے ایک شامل کریں۔',
    noDeliveries: 'ابھی کچھ نہیں بھیجا گیا',
    eventCount: 'ایونٹس: {{count}}',
    open: 'کھولیں',
    openLabel: '{{url}} کھولیں',
    created: 'اینڈ پوائنٹ شامل ہو گیا',
    secret: 'سائننگ راز',
    secretLabel: 'سائننگ راز',
    verifiedAt: 'ٹیسٹ کا جواب ملا {{time}}',
    notVerified: 'ابھی ٹیسٹ نہیں ہوا',
    previousValid: 'پچھلا راز بھی {{time}} تک سائن کرتا ہے۔',
    blocked:
      'اس اینڈ پوائنٹ کا ہوسٹ اجازت یافتہ ہوسٹس کی فہرست میں نہیں، اس لیے اسے ڈلیوری مسترد ہوتی ہے۔ ہوسٹ کو ”اجازت یافتہ ہوسٹ“ میں شامل کریں۔',
    failingNote:
      'مسلسل ناکام کوششیں: {{count}}۔ ڈلیوری تقریباً تین دن تک دوبارہ کوشش کی جاتی ہے؛ مسلسل ناکام اینڈ پوائنٹ بند کر دیا جاتا ہے۔',
    edit: 'ترمیم کریں',
    status: {
      active: 'فعال',
      failing: 'توجہ درکار',
    },
    disabled: {
      manual: 'بند',
      failing: 'بند: مسلسل ناکام',
      gone: 'بند: اینڈ پوائنٹ موجود نہیں',
    },
    columns: {
      url: 'پتہ',
      status: 'حالت',
      events: 'ایونٹس',
      latest: 'آخری ڈلیوری',
      open: 'تفصیل',
    },
    categories: {
      conversations: 'گفتگو',
      messages: 'پیغامات',
      handoffs: 'انسان کو منتقلی',
      orders: 'آرڈرز',
      payments: 'ادائیگیاں',
      refunds: 'ریفنڈز',
      memory: 'گاہک میموری',
      usage: 'استعمال',
      testing: 'ٹیسٹنگ',
    },
    events: {
      conversation_created: 'ایک گفتگو شروع ہوئی۔',
      conversation_updated: 'کون جواب دیتا ہے، یا گاہک کو نظر آنے والی حالت بدلی۔',
      conversation_resolved: 'ایک گفتگو حل ہوئی۔',
      conversation_reopened: 'ایک گفتگو دوبارہ کھلی۔',
      message_created: 'گاہک کو نظر آنے والا پیغام بھیجا گیا۔',
      handoff_requested: 'گفتگو کسی انسان کی منتظر ہے۔',
      handoff_accepted: 'کسی انسان نے گفتگو سنبھالی۔',
      handoff_returned: 'گفتگو AI معاون کو واپس گئی۔',
      order_created: 'ایک آرڈر دیا گیا۔',
      order_updated: 'آرڈر کی حالت بدلی۔',
      payment_updated: 'ادائیگی کی حالت بدلی۔',
      refund_created: 'ریفنڈ کی درخواست ہوئی۔',
      refund_updated: 'ریفنڈ کی حالت بدلی۔',
      memory_deleted: 'گاہک میموری حذف ہوئی (مواد کے بغیر رسید)۔',
      usage_threshold_reached: 'استعمال الرٹ کی حد تک پہنچا۔',
      webhook_test: 'Studio یا API سے بھیجا گیا آزمائشی ایونٹ۔',
    },
    form: {
      title: 'اینڈ پوائنٹ شامل کریں',
      editTitle: 'اینڈ پوائنٹ میں ترمیم کریں',
      description:
        'عوامی انٹرنیٹ پر HTTPS پتہ استعمال کریں۔ شامل کرنے کے بعد سائننگ راز ایک بار دکھایا جاتا ہے۔',
      url: 'اینڈ پوائنٹ کا پتہ',
      urlHint: 'مثال: https://hooks.example.com/hamnivo',
      note: 'تفصیل',
      events: 'بھیجے جانے والے ایونٹس',
      submit: 'اینڈ پوائنٹ شامل کریں',
      save: 'تبدیلیاں محفوظ کریں',
      saved: 'اینڈ پوائنٹ محفوظ ہو گیا۔',
    },
    test: {
      button: 'ٹیسٹ ایونٹ بھیجیں',
      verified: 'آپ کے اینڈ پوائنٹ نے سائن شدہ ٹیسٹ ایونٹ قبول کر لیا۔',
      verifiedBadge: 'تصدیق شدہ',
      failed: 'ٹیسٹ ایونٹ قبول نہیں ہوا۔ نیچے جواب دیکھیں۔',
    },
    rotate: {
      button: 'راز روٹیٹ کریں',
      title: 'سائننگ راز روٹیٹ کریں؟',
      description:
        'اوورلیپ کے دوران ہر درخواست میں دو دستخط ہوتے ہیں، ہر راز کے لیے ایک، تاکہ آپ کا ریسیور کوئی ایونٹ کھوئے بغیر بدل سکے۔',
      overlap: 'پرانے راز سے سائن کرتے رہیں',
      overlaps: {
        '0': 'بالکل نہیں: ابھی بند',
        '1': 'ایک گھنٹہ',
        '24': 'ایک دن',
        '72': 'تین دن',
      },
      confirm: 'راز روٹیٹ کریں',
      unchanged: 'راز روٹیٹ نہیں ہوا؛ موجودہ راز اب بھی سائن کرتا ہے۔',
      revealTitle: 'نیا سائننگ راز',
    },
    turnOff: {
      button: 'بند کریں',
      title: 'یہ اینڈ پوائنٹ بند کریں؟',
      description:
        'اسے مزید کچھ نہیں بھیجا جائے گا، اور دوبارہ کوشش کی منتظر ڈلیوریز منسوخ ہوں گی۔ چالو کرنے کے بعد آپ انہیں دوبارہ بھیج سکتے ہیں۔',
      confirm: 'بند کریں',
      done: 'اینڈ پوائنٹ بند کر دیا گیا۔',
    },
    turnOn: {
      button: 'چالو کریں',
      title: 'یہ اینڈ پوائنٹ چالو کریں؟',
      description: 'نئے ایونٹس دوبارہ بھیجے جائیں گے، اور ناکامیوں کی گنتی صفر سے شروع ہو گی۔',
      confirm: 'چالو کریں',
      done: 'اینڈ پوائنٹ چالو کر دیا گیا۔',
    },
    replayFailed: {
      button: 'ناکام دوبارہ بھیجیں',
      title: 'ناکام ڈلیوریز دوبارہ بھیجیں؟',
      description:
        'اس مدت میں اس اینڈ پوائنٹ کی ہر ناکام یا منسوخ ڈلیوری اُسی اصل ایونٹ ID کے ساتھ دوبارہ بھیجی جائے گی۔',
      since: 'جو ناکام ہوئیں',
      windows: {
        '1': 'پچھلے 24 گھنٹے',
        '3': 'پچھلے 3 دن',
        '7': 'پچھلے 7 دن',
      },
      confirm: 'ڈلیوریز دوبارہ بھیجیں',
      done: 'دوبارہ بھیجنے کے لیے قطار میں: {{count}}۔ دوبارہ بھیجنے کے لیے بہت پرانی: {{expired}}۔',
    },
    delete: {
      button: 'حذف کریں',
      title: 'یہ اینڈ پوائنٹ حذف کریں؟',
      description:
        'اس کی ڈلیوری کی تاریخ بھی حذف ہو گی اور اس کے سائننگ راز کام کرنا بند کر دیں گے۔ اسے واپس نہیں کیا جا سکتا۔',
      confirm: 'اینڈ پوائنٹ حذف کریں',
      done: 'اینڈ پوائنٹ حذف کر دیا گیا۔',
    },
  },
  deliveries: {
    title: 'ڈلیوری کی تاریخ',
    loading: 'ڈلیوریز لوڈ ہو رہی ہیں',
    loadingDetail: 'ڈلیوری لوڈ ہو رہی ہے',
    empty: 'اس اینڈ پوائنٹ پر ابھی کچھ نہیں بھیجا گیا۔',
    detailTitle: 'ڈلیوری کی تفصیل',
    event: 'ایونٹ',
    eventId: 'ایونٹ ID',
    statusLabel: 'حالت',
    attempts: 'کوششیں',
    attemptsOf: 'کوششیں: {{max}} میں سے {{count}}',
    attemptNumber: 'کوشش {{number}}',
    nextAttempt: 'اگلی کوشش',
    replayed: 'دوبارہ بھیجی گئی',
    answer: 'جواب:',
    preview: 'پے لوڈ کا جائزہ',
    previewNote:
      'لوگوں نے کیا لکھا اور وہ کون ہیں، یہ یہاں چھپا ہے؛ آپ کے اینڈ پوائنٹ کو پورا ایونٹ ملا۔',
    expired: 'ایونٹ محفوظ رکھنے کی مدت سے پرانا ہے، اس لیے اس کا مواد اب نہیں رکھا جاتا۔',
    status: {
      pending: 'دوبارہ کوشش جاری',
      succeeded: 'ڈلیور ہو گیا',
      failed: 'ناکام',
      cancelled: 'منسوخ',
    },
    outcomes: {
      succeeded: 'قبول',
      http_error: 'غلطی والا جواب',
      redirect: 'ری ڈائریکٹ (فالو نہیں کیا)',
      timeout: 'وقت ختم',
      network: 'کنکشن ناکام',
      tls: 'سرٹیفکیٹ کا مسئلہ',
      blocked: 'مسترد',
      unresolvable: 'ہوسٹ نہیں ملا',
    },
    replay: {
      button: 'یہ ڈلیوری دوبارہ بھیجیں',
      title: 'یہ ڈلیوری دوبارہ بھیجیں؟',
      description: '{{event}} ایونٹ دوبارہ بھیجیں:',
      dedupe:
        'ریسیورز کو ایونٹ ID سے دہراؤ ختم کرنا چاہیے: دوبارہ بھیجی گئی ڈلیوری میں اصل والا ہی webhook-id ہوتا ہے۔',
      confirm: 'ڈلیوری دوبارہ بھیجیں',
      queued: 'دوبارہ بھیجنا قطار میں ہے۔',
      turnOnFirst: 'ڈلیوریز دوبارہ بھیجنے کے لیے اینڈ پوائنٹ چالو کریں۔',
    },
  },
  events: {
    title: 'ایونٹ لاگ',
    description: 'آپ کے اینڈ پوائنٹس پر بھیجے گئے ایونٹس، نئے پہلے، ان کی ڈلیوری کے حال کے ساتھ۔',
    filter: 'ایونٹ کی قسم',
    allTypes: 'تمام ایونٹ اقسام',
    loading: 'ایونٹس لوڈ ہو رہے ہیں',
    empty: 'ابھی کوئی ایونٹ نہیں۔ کم از کم ایک اینڈ پوائنٹ چالو ہونے پر ایونٹس درج ہوتے ہیں۔',
    emptyFiltered: 'اس قسم کے ایونٹس ابھی نہیں ہیں۔',
    more: 'پرانے ایونٹس دکھائیں',
    counts: 'ڈلیور {{succeeded}} · ناکام {{failed}} · دوبارہ کوشش {{pending}}',
    columns: {
      type: 'ایونٹ',
      id: 'ایونٹ ID',
      occurred: 'کب ہوا',
      deliveries: 'ڈلیوریز',
    },
  },
  hosts: {
    title: 'اجازت یافتہ ہوسٹ',
    description:
      'اس ورک اسپیس کے لیے Hamnivo کن ہوسٹس کو کال کر سکتا ہے، جیسے آپ کے ویب ہُک اینڈ پوائنٹس، اسے محدود کریں۔ کوئی ہوسٹ درج نہ ہو تو کوئی بھی عوامی ہوسٹ اجازت یافتہ ہے۔',
    always: 'نجی نیٹ ورک، یہ سرور اور مقامی پتے ہمیشہ مسترد ہوتے ہیں، یہاں چاہے کچھ بھی درج ہو۔',
    loading: 'اجازت یافتہ ہوسٹ لوڈ ہو رہے ہیں',
    modeAny: 'کوئی بھی عوامی ہوسٹ اجازت یافتہ ہے۔',
    modeList: 'صرف نیچے دیے گئے ہوسٹ اجازت یافتہ ہیں۔',
    empty: 'کوئی ہوسٹ درج نہیں۔',
    pattern: 'ہوسٹ',
    patternHint: 'hooks.example.com جیسا ہوسٹ، یا اس کے سب ڈومینز کے لیے ‎*.example.com۔',
    note: 'نوٹ',
    remove: '{{host}} ہٹائیں',
    removeShort: 'ہٹائیں',
    add: 'ہوسٹ شامل کریں',
    save: 'اجازت یافتہ ہوسٹ محفوظ کریں',
    savedList: 'اجازت یافتہ ہوسٹ محفوظ ہوئے: {{count}}۔',
    savedAny: 'محفوظ ہو گیا۔ کوئی بھی عوامی ہوسٹ اجازت یافتہ ہے۔',
    readOnly: 'نیٹ ورک کی فہرست صرف اسے سنبھالنے والے لوگ بدل سکتے ہیں۔',
    blocked: 'یہ اینڈ پوائنٹس فہرست میں نہیں، اس لیے انہیں ڈلیوری مسترد ہوتی ہے:',
  },
};
